import Socket from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { setOnsiteUsers, setAdvancedAudioUsers } from '../stores/actions/session';
import { GreenroomState } from '../stores/types/types';
import { SOCKET_MESSAGE_TYPES } from '../types/constants';
import { showAlert } from '../components/general-components/alert-service';

function handleOnsiteUsers(message: any) {
	const onsiteUsers = message.message as GreenroomState['SessionReducer']['onsiteUsers'];
	socketListenerDispatch(setOnsiteUsers(onsiteUsers));
}

function kickUser(message: any) {
	const {
		SessionReducer: {
			user,
		},
	} = getState();

	if (user && message.message.email === user.email) {
		console.log(message.message.method);
		window.location.reload();
	}
}

function handleGreenroomAlert(socketMessage: any) {
	const { message } = socketMessage;
	const {
		SessionReducer: {
			host,
		},
	} = getState();

	if (!message.host || (message.host && host)) {
		showAlert({
			message: message.message,
			description: message.description,
			duration: message.duration,
			type: message.type,
		});
	}
}

function handleAdvancedAudioUsers(message: any) {
	const advancedAudioUsers = message.message as GreenroomState['SessionReducer']['advancedAudioUsers'];
	socketListenerDispatch(setAdvancedAudioUsers(advancedAudioUsers));
}

export default function Session(socket: Socket) {
	socket.addListener('onsite-users', handleOnsiteUsers);
	socket.addListener('kick-user', kickUser);
	socket.addListener(SOCKET_MESSAGE_TYPES.GREENROOM_ALERT, handleGreenroomAlert);
	socket.addListener('advanced-audio-users', handleAdvancedAudioUsers);
}
